module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAMAAAD6fQULAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOwwAADsMBx2+oZAAAADNQTFRFAAAAqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqDTV8hAAAABF0Uk5TAAWfBoH/MPox0oIvVy3D88wJyrSQAAAARklEQVR4nIXKSwrAIAxF0dT4tNbv/lfbCEYdCN7ZgUt06zG8ycIuOA//KjgACDy/3jcUkyBFXbMo000oUwUHjbpq06po7wfONwL4M1jtZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/workOrder/Uploadicon.png
// module id = YEl4
// module chunks = 1